module.exports = __webpack_public_path__ + "assets/img/5_1277.c6a9be5f.jpg";